import React, { useRef, useEffect, useContext, useState } from 'react'
import { Grid, Selector, Slider, Switch } from 'antd-mobile'
import { } from 'antd'

type CustomSliderProps = {
    title: string
    value: number
    onChange: (...args: any) => void
}
const CustomSlider = (props: CustomSliderProps) => {
    const {
        title,
        value,
        onChange
    } = props

    return (
        <div
            className="slider-container"
        >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span
                    style={{
                        color: '#131155',
                    }}
                >{title}</span>
                <span
                    style={{
                        width: '102px',
                        color: '#5B56ED',
                        background: 'rgba(91, 86, 237, .08)',
                        borderRadius: '8px',
                        padding: '2px 8px'
                    }}
                >{(value / 50).toFixed(2)}</span>
            </div>
            <Slider
                className='slider-adjuster'
                value={value}
                onChange={onChange}
                min={-50}
                max={50}
            />
        </div>
    )
}

export default CustomSlider
